// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1663":"2ba5f347","5163":"6d2ccf55","7761":"2ba5f347","8465":"2ba5f347"}[chunkId] + ".chunk.css";
};